import React from "react";

import { cn } from "../utils/carteInteretsUtils";

export default function TypeFilterChip({
  active,
  label,
  count,
  color,
  onClick,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "inline-flex shrink-0 items-center gap-2 rounded-full border px-4 py-2 text-sm font-bold transition",
        active
          ? "border-transparent text-white shadow-sm"
          : "border-slate-200 bg-white text-slate-700 hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:hover:bg-slate-900"
      )}
      style={active ? { backgroundColor: color } : undefined}
    >
      <span
        className="h-2.5 w-2.5 rounded-full"
        style={{ backgroundColor: active ? "#fff" : color }}
      />
      {label}
      <span
        className={cn(
          "rounded-full px-2 py-0.5 text-xs",
          active
            ? "bg-white/20 text-white"
            : "bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-300"
        )}
      >
        {count}
      </span>
    </button>
  );
}